import { client } from "../../api/client"
import { getNoteById } from "../../features/tickets/data/localTicketCommentStore"

export const fetchTicketNoteById = async (id) => {
    // If using local data, return the note from the local store. This prevents crashes
    // if we get an unexpected SignalR notification (we shouldn't, but...)
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return getNoteById(id)
    }

    var uri = "autotaskapi/ticketnotes/" + id
    var responseAutotask = await client.get(uri)
    return responseAutotask.data
}